import { Button, Col, Container, FormGroup, Input, Label, Row } from "reactstrap";
import { ChangeEvent, FormEvent, use, useState } from "react";
import { v4 } from "uuid";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import { useRouter } from "next/router";
import { Captcha, EmailAddress, EnterSatuAccount, ImgPath, Password, SignIn, SignInAccount } from "utils/Constant";
import RatioImage from "utils/RatioImage.tsx";
import CommonLogo from "@/components/authentication/Others/common/CommonLogo";
import { osmUserGroup } from "Types/OSM/Group";
import { sidebarMenuType } from "Types/LayoutDataType";
import { HttpBuildQuery } from "@/lib/http";
import { OSMtoMenu } from "@/lib/osm";
import { User } from "react-feather";

const API_KEY = process.env.NEXT_PUBLIC_API_KEY as string;

const generateCaptcha = () => {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let captcha = "";
  for (let i = 0; i < 4; i++) {
    captcha += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return captcha;
};

export const getGroups = async (param: number): Promise<osmUserGroup[]> => {

  const response = await fetch('/api/doServices', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      method: 'GET',
      endpoint: `users/${param}/groups?page=1&limit=100`,
      isForm: false,
      isImage: false,
    }),
  });

  if (response.status !== 200) {
    return [];
  }

  const result = await response.json();

  // Jika API mengembalikan http_code != 200 atau data kosong, return []
  if (result.http_code !== 200 || !result.data) {
    return [];
  }

  return result.data;
}

export const getMenu = async (id: number): Promise<sidebarMenuType[]> => {
  const queryParam = {
    limit: 300,
    page: 1,
    group_id: id,
    order: "urutan"
  }

  const queryString = HttpBuildQuery(queryParam);

  const response = await fetch('/api/doServices', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      method: 'GET',
      endpoint: `office/modul/nested?${queryString}`,
      isForm: false,
      isImage: false,
    }),
  });

  // console.log('fetch menu response', response);

  if (response.status !== 200) {
    return [];
  }

  const result = await response.json();

  const mappingMenu = OSMtoMenu(result.data)

  return [
    {
      title: "OFFICE",
      menucontent: "OFFICE",
      Items: mappingMenu,
    },
  ];
}

const Login = () => {
  const [showPassWord, setShowPassWord] = useState(false);
  const [formValues, setFormValues] = useState({
    username: "",
    password: "",
    reCaptcha: "",
  });

  const [captcha, setCaptcha] = useState(generateCaptcha());
  const { username, password, reCaptcha } = formValues;
  const router = useRouter();
  const handleUserValue = (event: ChangeEvent<HTMLInputElement>) => {
    setFormValues({ ...formValues, [event.target.name]: event.target.value });
  };
  const formSubmitHandle = async (event: FormEvent) => {
    event.preventDefault();
    if (captcha !== reCaptcha) {
      toast.error("captcha tidak sesuai, mohon input kembali");
      setCaptcha(generateCaptcha)
      return;
    }

    try {
      const param = {
        username: username,
        password: password
      }

      const response = await fetch('/api/doServices', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          method: 'POST',
          endpoint: 'login',
          body: param,
          isForm: false,
          isImage: false,
        }),
      });

      // console.log('login response', response);


      if (response.status === 200) {
        const result = await response.json();
        if (result.http_code == 404) {
          toast.error('Gagal login, username dan password tidak sesuai')
          return;
        }
        const userData = result.data

        let listGroup = await getGroups(userData.users_id);

        // Fallback jika API group gagal / kosong (sama seperti PHP)
        if (listGroup.length === 0) {
          switch (userData.group) {
            case "DSN":
              listGroup = [{
                id: 0,
                groups_id: 582,
                users_id: userData.users_id,
                groups_nama: "DSN",
                app_name: "",
                users_nama: userData.name || "",
                profil: "",
              }];
              break;
            case "PEGAWAI":
              listGroup = [{
                id: 0,
                groups_id: 582,
                users_id: userData.users_id,
                groups_nama: "PEGAWAI",
                app_name: "",
                users_nama: userData.name || "",
                profil: "",
              }];
              break;
            default:
              toast.error('anda tidak memiliki akses di sistem ini');
              return;
          }
        }

        userData.listGroup = listGroup;

        const defaultGroup = listGroup.find(g => g.groups_nama === "PEGAWAI") ?? listGroup[0];
        const listMenu = await getMenu(defaultGroup.groups_id);
        if (listMenu.length === 0) {
          toast.error('modul belum di iniasi');
          return;
        }
        userData.listMenu = listMenu

        const UserDataAppMap: Record<string, typeof userData> = {};
        UserDataAppMap[API_KEY] = userData;

        const sessResponse = await fetch('/api/session/set', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(UserDataAppMap),
        });

        if (sessResponse.ok) {
          // console.log('Login successful:', sessResponse.json);
          const { sessionId } = await sessResponse.json();
          Cookies.set('osm_sess', sessionId, {
            expires: 1,
            path: "/",
            domain: process.env.NEXT_PUBLIC_COOKIE_DOMAIN
          });
          toast.success('Berhasil Login');
          window.location.reload();
        }

      } else {
        toast.error(response.statusText)
      }
    } catch (error) {
      toast.error(error.body);
    }

  };

  return (
    <Container fluid>
      <Row>
        <Col xl={7} className="b-center bg-size">
          <RatioImage className="bg-img-cover bg-center img-fluid w-100" src={`../${ImgPath}/ido_bg.png`} alt="" />
        </Col>
        <Col xl={5} className="p-0">
          <div className="login-card login-dark">
            <div>
              <div><CommonLogo alignLogo="text-center" /></div>
              <div className="login-main">
                <form className="theme-form" onSubmit={formSubmitHandle}>
                  <h4>{SignInAccount}</h4>
                  <p>{EnterSatuAccount}</p>
                  <FormGroup>
                    <Label className="col-form-label">{EmailAddress}</Label>
                    <Input type="text" name="username" required placeholder="NIP/Username" onChange={handleUserValue} />
                  </FormGroup>
                  <FormGroup>
                    <Label className="col-form-label">{Password}</Label>
                    <div className="form-input position-relative">
                      <Input type={showPassWord ? "text" : "password"} name="password" placeholder="Password" onChange={handleUserValue} />
                      <div className="show-hide">
                        <span onClick={() => setShowPassWord(!showPassWord)} className={!showPassWord ? "show" : ""} />
                      </div>
                    </div>
                  </FormGroup>
                  <FormGroup>
                    <Label className="col-form-label"></Label>
                    <div className="form-input posittion-relative text-center">
                      <h2>
                        <span className="badge badge-primary">{captcha}</span>
                      </h2>
                    </div>
                  </FormGroup>
                  <FormGroup>
                    <Label className="col-form-label">{Captcha}</Label>
                    <div className="form-input position-relative">
                      <Input type="text" placeholder="ketik 4 huruf di atas" name="reCaptcha" onChange={handleUserValue} />
                    </div>
                  </FormGroup>
                  <FormGroup className="mb-0 position-relative">
                    <div className="text-end mt-3">
                      <Button color="primary" className="btn-block w-100" type="submit">{SignIn}</Button>
                    </div>
                  </FormGroup>
                  <div className="text-center mt-4">
                    <p className="mb-2 text-muted">atau</p>
                    <Button
                      color="success"
                      className="w-100"
                      onClick={() => router.push('/kotak_surat')}
                      type="button"
                    >
                      PO Box
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Login;
